import moment from "moment";

const utilityMixin = {
  methods: {
    formatTime(time) {
      return time ? moment(time).format("h:mm A") : "";
    },

    formatDate(date) {
      return date ? moment(date).format("MMMM D, YYYY") : null;
    },

    formatDatetime(datetime) {
      return datetime ? moment(datetime).format("MMMM D YYYY h:mm A") : null;
    },
  },
};

export default utilityMixin;
